import React, { useEffect } from 'react'
import ReviewDetailModal from './ReviewDetailModal'
import { Layout } from 'antd'
import TopNav from './TopNav'
import { Content, Header } from 'antd/es/layout/layout'
import useSetTitle from './GlobalSetTitleHook'
export const AuditHistoryDetail = () => {
    useSetTitle();
    const [record, setRecord] = React.useState<any>(null)
    useEffect(()=>{
        const ida = window.location.search.split("id=")
        if (ida.length > 1) {
            setRecord({id: ida[1].split('&')[0]})
        }
    }, [])
  return (
    <Layout className="layout">
        <Header style={{ background: '#f0f2f5', padding: 0 }}>
            <TopNav />
        </Header>
        <Content>
            <ReviewDetailModal isModal={false} visible={true} onClose={()=>{}} record={record}/>
        </Content>
    </Layout>
  )
}
